// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e3cbeda0","732":"66a27b1b","977":"65b29213"}[chunkId] + ".chunk.js";
};